import React from "react";
import { Instagram, Facebook, Twitter, Youtube } from "lucide-react";
import Container from "./container";

function FooterCol({ title, links }) {
  return (
    <div>
      <div className="text-sm font-extrabold text-black/80">{title}</div>
      <ul className="mt-3 space-y-2">
        {links.map((l) => (
          <li key={l}>
            <a
              href="/products"
              className="text-sm font-medium text-black/55 hover:text-black/80"
            >
              {l}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function Footer() {
  return (
    <footer id="footer" className="border-t border-black/10 bg-[#fbf7f1]">
      <Container className="py-10">
        <div className="grid gap-8 lg:grid-cols-2">
          <div>
            <div className="text-base font-extrabold">Retro Revive</div>
            <p className="mt-2 text-sm font-medium leading-relaxed text-black/55">
              Your one-stop shop for vintage collectibles and retro gifts.
            </p>

            <div className="mt-4 flex items-center gap-2">
              {[Instagram, Facebook].map((Icon, idx) => (
                <button
                  key={idx}
                  className="rounded-xl border border-black/10 bg-white p-2 text-black/60 shadow-sm transition hover:bg-black/5"
                  aria-label="Social link"
                  onClick={() =>
                    idx === 0
                      ? window.open(
                          "https://www.instagram.com/retro_revive_bd/",
                          "_blank"
                        )
                      : window.open(
                          "https://www.facebook.com/retrorevive.bangladesh/",
                          "_blank"
                        )
                  }
                >
                  <Icon className="h-4 w-4" />
                </button>
              ))}
            </div>
          </div>

          <FooterCol title="Shop" links={["All Products"]} />
          {/* <FooterCol
            title="Support"
            links={["Contact Us", "FAQs", "Shipping", "Returns"]}
          /> */}
          {/* <FooterCol
            title="Company"
            links={["About Us", "Blog", "Careers", "Press"]}
          /> */}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-black/10 pt-6 text-xs font-medium text-black/50 sm:flex-row">
          <div>
            © {new Date().getFullYear()} Retro Revive. All rights reserved.
          </div>
          <div className="flex items-center gap-5">
            <a className="hover:text-black/80" href="#">
              Privacy Policy
            </a>
            <a className="hover:text-black/80" href="#">
              Terms of Service
            </a>
          </div>
        </div>
      </Container>
    </footer>
  );
}
